import { createStyles, Theme } from "@material-ui/core";
import Constants from "../models/utility/Constants";

const nodeWidth = 80;
const nodeWidthMobile = 60;
const nodeMinHeight = 0;
const rootnodeMinHeight = 250;

// Where a node sits on the dashed timeline. A "single" node draws no line.
export type TimelinePosition = "start" | "middle" | "end" | "single";

export const styles = (theme: Theme) =>
    createStyles({
        auctionStartText: { color: theme.palette.common.white },
        bidBlockBottom: {
            [theme.breakpoints.down("xs")]: { maxWidth: nodeWidthMobile },
            alignItems: "center",
            display: "flex",
            flexBasis: "38%",
            flexDirection: "column",
            justifyContent: "flex-start",
            maxWidth: nodeWidth
        },
        bidBlockMiddle: {
            alignItems: "center",
            display: "flex",
            flexBasis: "24%",
            justifyContent: "center"
        },
        bidBlockTop: {
            [theme.breakpoints.down("xs")]: { maxWidth: nodeWidthMobile },
            alignItems: "flex-end",
            display: "flex",
            flexBasis: "38%",
            justifyContent: "center",
            maxWidth: nodeWidth
        },
        bidButton: {
            [theme.breakpoints.down("xs")]: {
                "& span": { fontSize: 12 },
                height: 36,
                width: 36
            }
        },
        bidNodeWrapper: {
            [theme.breakpoints.down("xs")]: {
                maxWidth: nodeWidthMobile,
                minWidth: nodeWidthMobile
            },
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: nodeWidth,
            minHeight: nodeMinHeight,
            minWidth: nodeWidth,
            position: "relative",
            textAlign: "center",
            backgroundColor: "#535353"
        },
        root: {
            display: "flex",
            maxWidth: theme.spacing(114),
            minHeight: rootnodeMinHeight,
            overflowX: "scroll",
            overflowY: "hidden",
            position: "relative",
            width: "100%",
            backgroundColor: "#535353"
        },
        textBase: {
            letterSpacing: "0.04em",
            lineHeight: 1.25
        },
        textBid: { color: "#C0C0C0" },
        textBidAmount: {
            [theme.breakpoints.down("xs")]: { fontSize: 10 },
            fontSize: 12
        },
        textBidNext: {
            fontWeight: "bold",
            marginTop: theme.spacing()
        },
        textBidUser: { color: theme.palette.success.main },
        textTime: {
            [theme.breakpoints.down("xs")]: { fontSize: 12 },
            fontSize: 14
        },
        textTop: {
            [theme.breakpoints.down("xs")]: { fontSize: 10 },
            fontSize: 12
        },
        timeline: {
            alignItems: "center",
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            left: 0,
            position: "absolute",
            right: 0,
            top: 0
        },
        timelineEnd: { alignItems: "flex-start" },
        timelineEndLine: { left: Constants.IsIE ? 0 : 1 },
        timelineStart: { alignItems: "flex-end" },
        timelineStartLine: { right: Constants.IsIE ? 0 : 1 },
        timelineStartOrEndLine: {
            position: "relative",
            width: "50% !important"
        },
        timelineTopLine: {
            borderBottom: `1px dashed ${theme.palette.secondary.main}`,
            flexBasis: "50%",
            width: Constants.IsIE ? "99%" : "97%"
        }
    });
